import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';

import SidebarItem from "../../SidebarItem";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../SidebarContext";
import {isString} from "formik";

RetailerEditItem.propTypes = {
    retailerId: PropTypes.string
};

function RetailerEditItem({retailerId}) {
    const {currentPath, currentFullPath, currentMemberAuthorizations, isUserAdmin, currentMember} = useContext(SidebarContext);

    const hasRetailerManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_RETAILER_MANAGEMENT);
    const hasRetailerProfileAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.OTHER_RETAILER_PROFILE);

    if (!isUserAdmin || (!hasRetailerManagementAuthorization && !hasRetailerProfileAuthorization )) {
        return null;
    }

    // Route here is an array
    const isItemSelected = (routes) => {
        if(typeof routes === 'string') {
            return false
        }

        if (!Array.isArray(routes)) {
            return false
        }

        // We use startsWith because of the "?origin=sidebar" which can be present or not depending of where you access the route (sidebar or merchants list)
        if (routes.some(route => route.startsWith(currentPath) || route.startsWith(currentFullPath))) {
            return true
        }

        return false
    }

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_EDIT(retailerId)}
            selected={isItemSelected([MarketplaceRoutes.RETAILER_EDIT(retailerId), MarketplaceRoutes.RETAILER_PROFILE(retailerId)])}
        >
            <FormattedMessage id='sidebar.item.retailer.edit' />
        </SidebarItem>
    );
}

export default RetailerEditItem;
